export type Point = {
  latitude: number;
  longitude: number;
};

/**
 * GEOSPATIAL CALCULATION TRANSFORM: Two coordinates → Distance in miles
 *
 * This function implements the Haversine formula to calculate the great-circle distance
 * between two points on Earth's surface. It accounts for Earth's curvature to provide
 * accurate distance measurements for fire department assignment.
 *
 * Transform: Geographic coordinates → Haversine distance calculation
 * Uses Earth's radius (3958.8 miles) to calculate great-circle distance between two points
 */
export function haversineDistanceMiles(point1: Point, point2: Point): number {
  const toRadians = (degrees: number) => (degrees * Math.PI) / 180;
  const R = 3958.8; // Radius of the Earth in miles

  // TRANSFORM: Coordinate differences → Radians
  const dLat = toRadians(point2.latitude - point1.latitude);
  const dLon = toRadians(point2.longitude - point1.longitude);

  // TRANSFORM: Haversine formula calculation
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(point1.latitude)) *
      Math.cos(toRadians(point2.latitude)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c; // Distance in miles
}
